import { Paper, Typography, makeStyles } from "@material-ui/core";
import React from "react";
const useStyle = makeStyles((theme) => ({
    paper: {
        padding: "12px 6px",
        margin: "0 0 40px 0",
        backgroundColor: "rgba(0,0,0,.02)",
    },
}));
export const AdminFormPaper = (props) => {
    const classes = useStyle();
    const { children, title } = props;
    return (React.createElement(Paper, { className: classes.paper },
        React.createElement(Typography, { variant: "h4" }, title),
        children));
};
//# sourceMappingURL=AdminFormPaper.js.map